import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";

import DropdownFormField from "../../components/localForms/dropdownFormField/dropdownFormField";
import Tooltip from "../../components/localForms/tooltip/tooltip";

const KontentItemInputTypeState = (props) => {
  const {
    data,
    errors,
    touched,
    values,
    meta,
    onChange,
    onBlur,
  } = props;

  const { elements } = data;

  // Setting up options array
  const options = elements.options.value.split("\n");

  return (
    <Col xs={12} md={6}>
      <Tooltip
        id={elements.id.value}
        tooltipMessage={elements.tooltip.value}
      >
        <DropdownFormField
          id={elements.id.value}
          type="select"
          errors={errors}
          touched={touched}
          values={values}
          meta={meta}
          name={elements.label.value}
          label={elements.label.value}
          placeholder={elements.placeholder_state.value}
          options={options}
          onChange={onChange}
          onBlur={onBlur}
        />
      </Tooltip>
    </Col>
  );
};

export const query = graphql`
  fragment KontentItemInputTypeState on kontent_item_input_type_state {
    id
    elements {
      id {
        value
      }
      label {
        value
      }
      options {
        value
      }
      required {
        value {
          codename
        }
      }
      tooltip {
        value
      }
      placeholder_state {
        value
      }
    }
  } 
`;

KontentItemInputTypeState.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  meta: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  values: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemInputTypeState;
